import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "preview-img__body d-flex justify-content-center align-items-center"
};
const _hoisted_2 = { class: "text-center" };
const _hoisted_3 = { style: { "word-break": "break-word" } };
const _hoisted_4 = { class: "preview-img__overlay" };
const _hoisted_5 = {
    key: 2,
    class: "preview-img__progress"
};
const _hoisted_6 = { class: "error-message__message" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "vue-drag-uploader__item preview-img",
        style: _normalizeStyle({ width: _ctx.size ? _ctx.size + 'px' : null, height: _ctx.size ? _ctx.size + 'px' : null }),
        onClick: _cache[2] || (_cache[2] =
            //@ts-ignore
            (...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
        _renderSlot(_ctx.$slots, "it", { item: _ctx.item }, () => [
            (_ctx.isImage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "preview-img__body",
                    style: _normalizeStyle({ 'background-image': 'url(' + (_ctx.item.thumb_url || _ctx.item.url) + ')', opacity: _ctx.state === 'completed' ? 1 : 0.5 })
                }, null, 4))
                : _createCommentVNode("", true),
            _cache[7] || (_cache[7] = _createTextVNode()),
            (!_ctx.isImage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", null, [
                            _createElementVNode("span", {
                                class: _normalizeClass([_ctx.icon, "fa-3x"])
                            }, null, 2)
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.fileName), 1)
                    ])
                ]))
                : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                (!_ctx.isReadonly)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "preview-img__remove-icon fa fa-times",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.deleteSelf()), ["stop", "prevent"]))
                    }))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "extra", { item: _ctx.item })
            ]),
            _cache[9] || (_cache[9] = _createTextVNode()),
            (_ctx.state === 'uploading')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                        class: "preview-img__progress-bar",
                        style: _normalizeStyle({ width: (_ctx.progress * 100) + '%' })
                    }, null, 4)
                ]))
                : _createCommentVNode("", true),
            _cache[10] || (_cache[10] = _createTextVNode()),
            (_ctx.state === 'fail')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "preview-img__error-message error-message",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop", "prevent"]))
                }, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "error-message__notice" }, "Upload fail", -1)),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.messages.error), 1)
                ]))
                : _createCommentVNode("", true)
        ])
    ], 4));
}
